import { styled } from "@mui/material";
import { BybDialog } from "@Components/game/common";

export const BuilderDialog = styled(BybDialog)(({ theme }) => `

  & .MuiPaper-root {
    min-width: 320px;
    max-width: 900px;
    background-color: ${theme.palette.dsBase.v100};
  }

  & .MuiDialogContent-root {
    padding-top: ${theme.spacing(2)} !important;
  }
`);